import React from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import { GeoAlt, ArrowRightCircleFill } from "react-bootstrap-icons";
import "./../../assets/css/TourCards.css";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../component/commanfile";

const TourCards = ({ tourSector }) => {
  const navigate = useNavigate();
  return (
    <div className="tour-cards-section">
      <Container>
        <div className="section-title-wrapper mb-5">
          <p className="text-muted mb-1 fw-bold">CHOOSE YOUR REGION</p>
          <h2>Destinations to Explore</h2>
        </div>
        
        <Row className="g-4">
          {tourSector?.map((destination) => (
            <Col key={destination.id} xs={12} sm={6} lg={3}
            onClick={() => navigate(`allpackeges/${destination.sector_id}`)}
            >
              <div className="tour-cards">
                <div className="tour-card-img-wrapper">
               <img
                    src={`${BASE_URL}/api/image?file=${encodeURIComponent(destination.image)}`}
                    alt={destination.sector_name}
                    className="tour-card-img"
/>
                  <div className="tour-card-gradient" />
                  
                  {/* Text Overlay on Image */}
                  <div className="overlay-info">
                    <h4>{destination.sector_name}</h4>
                    <Badge className="tour-badge">
                      <GeoAlt size={12} className="me-1" />
                      {destination?.groupTours?.length || 0} Group  | {destination?.fitPackages?.length || 0} Private 
                    </Badge>
                  </div>
                </div>

                <div className="tour-card-body">
                  <div className="tour-guests">
                    {destination.description || "Explore our exclusive packages for this region."}
                  </div>
                  <span className="view-link">
                    View All <ArrowRightCircleFill className="ms-1" />
                  </span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default TourCards;